import registerServiceworker from './registerServiceworker';
import { getBrowserInfo, Browser, isMinimumBrowserVersion } from 'owa-user-agent';
import { isFeatureEnabled } from 'owa-feature-flags';
import { DatapointStatus, PerformanceDatapoint } from 'owa-analytics';

export default async function initializeServiceWorker(windowObj: Window, app: string) {
    const dp = new PerformanceDatapoint('RegisterServiceWorker');
    const serviceWorkerContainer: ServiceWorkerContainer = windowObj.navigator?.serviceWorker;
    let reason: string;
    let registerError: Error;
    // Enabling service worker only on chrome, firefox
    if (serviceWorkerContainer) {
        reason = getReasonServiceIsNotSupported();
        if (!reason) {
            try {
                await registerServiceworker(windowObj, app, dp);
            } catch (e) {
                registerError = e;
            }
        } else if (serviceWorkerContainer.getRegistrations) {
            serviceWorkerContainer
                .getRegistrations()
                .then((registrations: ServiceWorkerRegistration[]) => {
                    for (let i = 0; i < registrations.length; ++i) {
                        registrations[i].unregister();
                    }
                });
        }
    } else {
        reason = 'SWNotAvailable';
    }

    dp.addCustomData([reason || 'success']);
    if (registerError) {
        dp.endWithError(DatapointStatus.ClientError, registerError);
    } else if (reason) {
        dp.endWithError(DatapointStatus.ServerError);
    } else {
        dp.end();
    }
}

function getReasonServiceIsNotSupported(): string {
    const { browser } = getBrowserInfo();
    let reason: string;
    if (isFeatureEnabled('fwk-prefetch-code-off')) {
        reason = 'Error_PrefetchDisabled';
    } else if (browser == Browser.CHROME || browser == Browser.EDGE_CHROMIUM) {
        if (isFeatureEnabled('fwk-prefetch-code-off-chromium') && !isMinimumBrowserVersion([77])) {
            reason = 'Error_ChromeMinVersion';
        }
    } else if (browser == Browser.EDGE) {
        if (!isFeatureEnabled('auth-ServiceWorkerEdge')) {
            reason = 'EdgeFlightOff';
        } else if (!isMinimumBrowserVersion([17, 17134])) {
            reason = 'EdgeMinVersion';
        }
    } else if (browser == Browser.SAFARI) {
        if (!isFeatureEnabled('auth-ServiceWorkerSafari')) {
            reason = 'SafariFlightOff';
        } else if (!isMinimumBrowserVersion([11, 1])) {
            reason = 'SafariMinVersion';
        }
    } else if (browser != Browser.FIREFOX) {
        reason = 'UnsupportedBrowser:' + browser;
    }
    return reason;
}
